import { Component, inject, signal, ViewChild } from '@angular/core';
import { TitleComponent } from '../../shared/components/title-component/title-component';
import { SearchBarComponent } from '../../shared/components/search-bar-component/search-bar-component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { StockDetailsComponents } from '../modal/stock-details-components/stock-details-components';
import { StockService } from '../service/stock-service';
import { ToastrService } from '../../shared/services/toastr-service';
import { StockGroupeService } from '../service/stock-groupe-service';
import { StockGroupeDetailsComponents } from '../modal/stock-groupe-details-components/stock-groupe-details-components';

@Component({
  selector: 'app-stock-groupe-component',
  imports: [
    TitleComponent,
    SearchBarComponent,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatSpinner
  ],
  templateUrl: './stock-groupe-component.html',
  styleUrl: './stock-groupe-component.css',
})
export class StockGroupeComponent {
  displayedColumns: string[] = ['groupe', 'qte', 'reste', 'action'];
  dataSource : MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  readonly dialog = inject(MatDialog);

  loading = false

  constructor(
    private stockService : StockGroupeService,
    private toastr : ToastrService
  ){

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.loadStockGroup()
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
  }

  loadStockGroup(){
    this.stockService.listStockByGroupe().subscribe({
      next : (res) =>{
        this.dataSource.data = res
      },
      error : (err) =>{
        this.toastr.error()
      }
    })
  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDetails(site : any){

    const dialogRef = this.dialog.open(StockGroupeDetailsComponents, {
      width : '1500px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : site
    });

    dialogRef.afterClosed().subscribe((result : any) => {
      this.loadStockGroup()
    });
  }
}

